import { render, staticRenderFns } from "./EmployeeViewTopTips.vue?vue&type=template&id=079c709f&"
import script from "./EmployeeViewTopTips.vue?vue&type=script&lang=js&"
export * from "./EmployeeViewTopTips.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeViewTopTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports